$(function(){

    const $DoctorsOnlineVideoModal = $('#DoctorsOnlineModalVideo');
    const $DoctorsOnlinevideoFrame = $('#DoctorsOnlineModalVideoFrame');
    const $DoctorsOnlinevideoSrc = $DoctorsOnlinevideoFrame.attr('src');

    $DoctorsOnlineVideoModal.on('hidden.bs.modal', function(){
        // when modal hides, turn off the video
        $DoctorsOnlinevideoFrame.attr('src', $DoctorsOnlinevideoSrc);
    });
});